export const keystoneConfig = {
	keystoneUrl: import.meta.env.VITE_KEYSTONE_URL ?? '',
	clientId: import.meta.env.VITE_KEYSTONE_COMPONENT_ID ?? '',
	redirectUri: `${window.location.origin}/auth/callback`,
	targetComponent: import.meta.env.VITE_KEYSTONE_TARGET_COMPONENT ?? '',
	autoSignIn: false,
	onSessionExpired: (): void => {
		window.location.href = '/';
	},
};
